import React from "react";

type Props = {
  fill?: string;
};
export const BarIcon: React.FC<Props> = ({ fill = "#828282" }) => (
  <svg
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75977 5C3.75977 4.73478 3.86512 4.48043 4.05266 4.29289C4.2402 4.10536 4.49455 4 4.75977 4H16.7598C17.025 4 17.2793 4.10536 17.4669 4.29289C17.6544 4.48043 17.7598 4.73478 17.7598 5C17.7598 5.26522 17.6544 5.51957 17.4669 5.70711C17.2793 5.89464 17.025 6 16.7598 6H4.75977C4.49455 6 4.2402 5.89464 4.05266 5.70711C3.86512 5.51957 3.75977 5.26522 3.75977 5ZM3.75977 10C3.75977 9.73478 3.86512 9.48043 4.05266 9.29289C4.2402 9.10536 4.49455 9 4.75977 9H16.7598C17.025 9 17.2793 9.10536 17.4669 9.29289C17.6544 9.48043 17.7598 9.73478 17.7598 10C17.7598 10.2652 17.6544 10.5196 17.4669 10.7071C17.2793 10.8946 17.025 11 16.7598 11H4.75977C4.49455 11 4.2402 10.8946 4.05266 10.7071C3.86512 10.5196 3.75977 10.2652 3.75977 10ZM3.75977 15C3.75977 14.7348 3.86512 14.4804 4.05266 14.2929C4.2402 14.1054 4.49455 14 4.75977 14H16.7598C17.025 14 17.2793 14.1054 17.4669 14.2929C17.6544 14.4804 17.7598 14.7348 17.7598 15C17.7598 15.2652 17.6544 15.5196 17.4669 15.7071C17.2793 15.8946 17.025 16 16.7598 16H4.75977C4.49455 16 4.2402 15.8946 4.05266 15.7071C3.86512 15.5196 3.75977 15.2652 3.75977 15Z"
      fill={fill}
    />
  </svg>
);
